import type { CatalogRow } from "@ext/enterprise/components/admin/settings/resources/model/CatalogRow";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

interface CatalogCellProps {
	row: CatalogRow;
}

export const CatalogCell = ({ row }: CatalogCellProps) => (
	<div className="flex min-w-0 flex-col">
		<TextOverflowTooltip className="text-sm font-medium">{row.title}</TextOverflowTooltip>
		{row.description && <TextOverflowTooltip className="text-xs text-muted">{row.description}</TextOverflowTooltip>}
	</div>
);
